// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__1cM0o"};